import { useState } from "react";

const DEFAULT_START_HOUR = 8;

// Drag-over highlighting + drop → reschedule. Handlers are per-line factories: handleDrop(lineId)(event).
export function useGanttDrag({ canDrag, days, cols, orders, onReschedule }) {
  const [dragOver, setDragOver] = useState(null);

  const dayFromEvent = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    return Math.min(days - 1, Math.max(0, Math.floor(((e.clientX - rect.left) / rect.width) * days)));
  };

  const handleDragOver = (lineId) => (e) => {
    if (!canDrag) return;
    e.preventDefault();
    setDragOver(`${lineId}-${dayFromEvent(e)}`);
  };

  const handleDragLeave = (lineId) => () =>
    setDragOver((c) => (c && c.startsWith(`${lineId}-`) ? null : c));

  const handleDrop = (lineId) => (e) => {
    e.preventDefault();
    setDragOver(null);
    if (!canDrag) return;
    const orderId = e.dataTransfer.getData("orderId");
    if (!orderId) return;
    const order = orders.find((o) => o.id === orderId);
    const existing = order?.start_date ? new Date(order.start_date) : new Date();
    const newStart = new Date(cols[dayFromEvent(e)]);
    newStart.setHours(existing.getHours() || DEFAULT_START_HOUR, existing.getMinutes() || 0, 0, 0);
    onReschedule(orderId, { start_date: newStart.toISOString(), line_id: lineId === "none" ? null : lineId });
  };

  return { dragOver, handleDragOver, handleDragLeave, handleDrop };
}
